<script>
import axios from "axios";

export default {
  name: "contactPage",
  data() {
    return {
      imgSrc: require('@/assets/images/contact/PP-graphics-home-imgm-05.png'),
      isImageLoaded: false,
      name:'',
      email:'',
      message:'',
      requestUrl:'https://schoolnet.monkeytree.com.hk/ppmember_send_email.jsp'
    }
  },
  created() {
    // 预加载图片
    this.preloadImage(this.imgSrc)
  },
  methods: {
    preloadImage(src) {
      const img = new Image()
      console.log(img)
      img.onload = () => {
        this.isImageLoaded = true
      }
      img.src = src
    },
    async submit() {
      if (!this.name || !this.email || !this.message) {
        this.$message({
          message: 'Please fill in all fields',
          type: 'warning'
        });
        return
      }
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
      if (!emailRegex.test(this.email)) {
        this.$message({
          message: 'Please enter a valid email address',
          type: 'warning'
        });
        return;
      }
      // eslint-disable-next-line no-useless-catch
      try {
        const res = await axios.get(this.requestUrl,{
          params: {
            name: this.name,
            email: this.email,
            message: this.message
          }
        })
        if(res.status === 200){
          this.$message({
            message: 'Message sent successfully!',
            type: 'success'
          })
        }else{
          this.$message({
            message: res.result,
            type: 'error'
          })
        }
      }catch (err){
        throw err;
      }
    }
  }
}
</script>

<template>
  <div class="contact-container">
    <div class="big-image">
      <div v-if="!isImageLoaded" class="image-loading">
        <i class="el-icon-loading loading-icon"></i>
      </div>
      <el-image v-else :src="imgSrc" fit="contain" class="fade-in-image"/>
    </div>
    <div class="container">
      <div class="contact-wrap">
        <h1>{{ $t('contact.contactUs') }}</h1>
        <p class="m-ptext">{{ $t('contact.text') }}</p>
        <div class="contact-form-box">
          <form class="form-content" @submit.prevent="submit">
            <div class="form-group">
              <div class="input-w">
                <span class="inline-label">{{ $t('contact.name') }}</span>
                <input type="text" v-model="name" class="form-input"/>
              </div>
            </div>
            <div class="form-group">
              <div class="input-w">
                <span class="inline-label">{{ $t('contact.email') }}</span>
                <input type="text" v-model="email" class="form-input"/>
              </div>
            </div>
            <div class="form-group">
              <div class="input-w" style="align-items: flex-start">
                <span class="inline-label" style="padding-top: 5px">{{ $t('contact.message') }}</span>
                <textarea v-model="message" rows="8" class="form-textarea"></textarea>
              </div>
            </div>

            <!-- Submit Button -->
            <button type="submit" class="submit-btn">{{ $t('contact.submit') }}</button>
          </form>
          <div class="tip">
            <p>{{ $t('contact.tip1') }}</p>
            <p style="margin-top: 10px;">{{ $t('contact.tip2') }}</p>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<style scoped lang="scss">
@use '@/styles/responsive.scss' as *;
.contact-container{
  width: 100%;
  @include media-max(lg){
    margin-top: 108px;
  }
  @include media-max(md){
    margin-top: 148px;
  }
  @include media-max(sm){
    margin-top: 111px;
  }
  .big-image{
    min-height: 70vh; /* 设置最小高度，确保布局稳定的同时允许内容扩展 */
    //display: flex;
    //align-items: center;
    //justify-content: center;
    overflow: hidden;
    position: relative;
    @include media-max(sm){
      min-height: 30vh;
    }
  }
  .contact-wrap{
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-top: 7%;
    margin-bottom: 20%;
    h1{
      color: #158800;
      font-size: 45px;
      line-height: 104px;
    }
    p{
      font-size: 20px;
      line-height: 32px;
    }
    .contact-form-box{
      margin-top: 5%;
      width: 40%;
      .form-content{
        display: flex;
        flex-direction: column;
        .form-group {
          margin-bottom: 16px;
          .input-w{
            display: flex;
            align-items: center; /* 保证 textarea 对齐 */
            border: 1px solid #707070;
            border-radius: 16px;
            overflow: hidden;
            .inline-label{
              color: #663300;
              margin-left: 15px;
              white-space: nowrap;
            }
            .form-input, .form-textarea{
              border: none;
              outline: none;
              padding: 12px;
              width: 100%;
              font-size: 16px;
              resize: none;
              background: transparent;
            }
          }
          //.form-input,
          //.form-textarea {
          //  width: 100%;
          //  padding: 12px;
          //  border: 1px solid #ccc;
          //  border-radius: 16px;
          //  font-size: 17px;
          //  transition: border-color 0.3s ease;
          //  &:focus{
          //    outline: none;
          //    border-color: #8b4513;
          //  }
          //}
          //.form-textarea {
          //  resize: vertical;
          //  min-height: 120px;
          //  padding: 12px;
          //  line-height: 1.5;
          //}
        }
        .submit-btn {
          display: block;
          padding: 12px 24px;
          color: #5A2A00;
          border: 1px solid #ddd;
          background: transparent;
          border-radius: 16px;
          font-size: 17px;
          cursor: pointer;
          align-self: flex-end;
          :hover {
            background-color: #e0e0e0;
          }
        }
        .form-input::-webkit-input-placeholder,
        .form-textarea::-webkit-input-placeholder {
          color: #5A2A00;
        }
      }
      .tip{
        margin-top: 8%;
        p{
          color: #5A2A00;
          //line-height: 15px;
        }

      }
    }
  }
}
@include media-max(lg){
  .contact-container{
    .contact-wrap{
      .contact-form-box{
        width: 50%;
      }
    }
  }
}
@include media-max(md){
  .contact-container{
    .contact-wrap{
      .m-ptext{

        padding: 0 76px;
      }
      p{
        text-align: center;
        margin-top: 23px;
        font-size: 12px;
        line-height: 20px;
      }
      .contact-form-box{
        width: 65%;
        .form-content{
          .form-input,
          .form-textarea {
            width: 100%;
            padding: 8px !important;
            border-radius: 16px;
            font-size: 14px !important;
            &:focus{
              outline: none;
              border-color: #8b4513;
            }
          }
        }
        .submit-btn {
          display: block;
          padding: 8px 30px !important;
          color: #5A2A00;
          border: 1px solid #ddd;
          background: transparent;
          border-radius: 16px;
          font-size: 14px !important;
          cursor: pointer;
          align-self: flex-end;
          :hover {
            background-color: #e0e0e0;
          }
        }
        .tip{
          margin-top: 73px;
        }
      }
    }
  }
}
/* 图片淡入动画 */
.fade-in-image{
  opacity: 0;
  animation: fadeIn 0.5s ease-in forwards;
}

/* 加载状态 */
.image-loading{
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #009344;
}

.loading-icon{
  font-size: 48px;
  animation: rotate 2s linear infinite;
}

/* 淡入动画 */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* 旋转动画 */
@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

</style>
<style>
.el-image img{
  max-width: 100% !important;
}
</style>